import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "../Styles/Header.css";
import Bar from "./Bar";
import Search from "./Search";
import { styled } from "styled-components";

function Header({ data }) {
  const router = useNavigate();
  const headerRef = useRef(null);
  const [stickyOffset, setStickyOffset] = useState(0);

  const handleLogo = () => {
    router("/");
  };

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;

    // Save the initial offset top of the header
    setStickyOffset(header.offsetTop);

    const handleScroll = () => {
      if (!headerRef.current) return;

      if (window.pageYOffset > stickyOffset) {
        headerRef.current.classList.add("sticky");
      } else {
        headerRef.current.classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [stickyOffset]);

  const logo = data?.[0]?.base_logo_b64 || "/default-logo.png";

  return (
    <div className="container-fluid" ref={headerRef}>
      <div
        className="row background_Color"
        style={{ minHeight: "40px", boxShadow: "0 5px 5px -5px #333" }}
      >
        <div className="col-sm-2" style={{ marginTop: "10px" }}>
          <img
            src={logo}
            className="logo ms-1 ms-3"
            alt="Logo"
            onClick={handleLogo}
            style={{ cursor: "pointer" }}
          />
        </div>

        <nav
          className="col-sm-8 d-flex justify-content-center align-items-center"
          style={{ marginTop: "10px" }}
        >
          <ul className="nav-list d-flex gap-4 list-unstyled mb-0">
            <li className="nevHeader">
              <Link
                to="/"
                className="head-top"
                style={{ textDecoration: "none" }}
              >
                <b style={{ color: "white" }}>Home</b>
              </Link>
            </li>
            <li className="nevHeader">
              <Link
                to="/about"
                className="head-top"
                style={{ textDecoration: "none" }}
              >
                <b style={{ color: "white" }}>About</b>
              </Link>
            </li>
            <li className="nevHeader">
              <Link
                to="/contact"
                className="head-top"
                style={{ textDecoration: "none" }}
              >
                <b style={{ color: "white" }}>Contact</b>
              </Link>
            </li>
          </ul>
        </nav>

        <div className="col-sm-2 mt-1">
          <Search />
          <Bar />
        </div>
      </div>
    </div>
  );
}

export default Header;
